export default __webpack_public_path__ + "static/media/icon_language.e20ba4d7.svg";